"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaStartDateProperty = exports.ctaStartDatePropertyDefinition = void 0;
exports.ctaStartDatePropertyDefinition = {
    view: { label: 'CTA start date' },
    constraints: [],
    type: 'date-time',
    multiple: false,
    name: 'cta-start-date',
};
const isCtaStartDateProperty = (prop) => {
    return prop.name === exports.ctaStartDatePropertyDefinition.name;
};
exports.isCtaStartDateProperty = isCtaStartDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLXN0YXJ0LWRhdGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9jdGEtc3RhcnQtZGF0ZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhCQUE4QixHQUFHO0lBQzVDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxnQkFBZ0IsRUFBRTtJQUNqQyxXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGdCQUFnQjtDQUNTLENBQUE7QUFJMUIsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLElBQWtCLEVBQWdDLEVBQUU7SUFDekYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNDQUE4QixDQUFDLElBQUksQ0FBQTtBQUMxRCxDQUFDLENBQUE7QUFGWSxRQUFBLHNCQUFzQiwwQkFFbEMifQ==